// Starter templates offered when creating a new form. Picking one pre-fills
// the editor (fields + theme); the user still edits and saves through the
// normal create flow. Keys mirror the shapes FormFieldsEditor/FormThemeEditor
// already read and write (field.key/type/label/required/placeholder/options,
// theme.primary_color/button_color/...).
//
// `icon` is a `i-lucide-*` class name, `color` drives the picker card accent
// and doubles as the template's theme.primary_color/button_color so the
// gallery preview matches what gets applied.

const field = overrides => ({
  required: false,
  placeholder: '',
  options: [],
  group_with_previous: false,
  ...overrides,
});

const baseTheme = color => ({
  primary_color: color,
  button_color: color,
  button_text_color: '#FFFFFF',
  background_color: '#F5F4EF',
  text_color: '#1B1B18',
  logo_url: '',
  header_image_url: '',
  radius: 16,
  font: 'sans',
  // New forms default to the steps (Typeform-style) layout — see
  // FormEditor.vue's defaultTheme(). Set explicitly here too so every
  // starter template is self-contained regardless of that default.
  layout: 'steps',
});

export const FORM_TEMPLATES = [
  {
    id: 'contact',
    name: 'Contato',
    description: 'Formulário simples de contato com mensagem livre.',
    icon: 'i-lucide-mail',
    color: '#146B57',
    fields: [
      field({ key: 'nome', type: 'text', label: 'Nome', required: true }),
      field({ key: 'email', type: 'email', label: 'Email', required: true }),
      field({ key: 'telefone', type: 'phone', label: 'Telefone' }),
      field({
        key: 'mensagem',
        type: 'textarea',
        label: 'Mensagem',
        required: true,
        placeholder: 'Como podemos ajudar?',
      }),
    ],
    theme: baseTheme('#146B57'),
  },
  {
    id: 'quote',
    name: 'Orçamento',
    description: 'Capture o serviço de interesse e os detalhes do pedido.',
    icon: 'i-lucide-calculator',
    color: '#1D4ED8',
    fields: [
      field({ key: 'nome', type: 'text', label: 'Nome', required: true }),
      field({
        key: 'telefone',
        type: 'phone',
        label: 'Telefone',
        required: true,
      }),
      field({ key: 'empresa', type: 'text', label: 'Empresa' }),
      field({
        key: 'servico',
        type: 'select',
        label: 'Serviço de interesse',
        required: true,
        options: ['Consultoria', 'Implantação', 'Suporte', 'Outro'],
      }),
      field({
        key: 'detalhes',
        type: 'textarea',
        label: 'Detalhes do orçamento',
        placeholder: 'Descreva o que você precisa',
      }),
    ],
    theme: baseTheme('#1D4ED8'),
  },
  {
    id: 'newsletter',
    name: 'Newsletter',
    description: 'Captação enxuta com nome, email e consentimento.',
    icon: 'i-lucide-mail-plus',
    color: '#7C3AED',
    fields: [
      field({ key: 'nome', type: 'text', label: 'Nome', required: true }),
      field({ key: 'email', type: 'email', label: 'Email', required: true }),
      field({
        key: 'consentimento',
        type: 'consent',
        label: 'Concordo em receber novidades por email.',
        required: true,
      }),
    ],
    theme: baseTheme('#7C3AED'),
  },
  {
    id: 'lead',
    name: 'Cadastro de lead',
    description: 'Qualifique o interesse do lead logo na entrada.',
    icon: 'i-lucide-user-plus',
    color: '#C2410C',
    fields: [
      field({ key: 'nome', type: 'text', label: 'Nome', required: true }),
      field({
        key: 'telefone',
        type: 'phone',
        label: 'Telefone',
        required: true,
      }),
      field({ key: 'email', type: 'email', label: 'Email' }),
      field({
        key: 'interesse',
        type: 'select',
        label: 'Interesse principal',
        options: ['Produto', 'Preço', 'Parceria', 'Outro'],
      }),
    ],
    theme: baseTheme('#C2410C'),
  },
  {
    id: 'scheduling',
    name: 'Agendamento',
    description: 'Reúna data e período preferido para o contato retornar.',
    icon: 'i-lucide-calendar-clock',
    color: '#4338CA',
    fields: [
      field({ key: 'nome', type: 'text', label: 'Nome', required: true }),
      field({
        key: 'telefone',
        type: 'phone',
        label: 'Telefone',
        required: true,
      }),
      field({
        key: 'data',
        type: 'date',
        label: 'Data preferida',
        required: true,
      }),
      field({
        key: 'periodo',
        type: 'select',
        label: 'Período',
        options: ['Manhã', 'Tarde', 'Noite'],
      }),
    ],
    theme: baseTheme('#4338CA'),
  },
];

export const getFormTemplateById = id =>
  FORM_TEMPLATES.find(template => template.id === id) || null;
